export enum ColorContrast {
  NORMAL = 'NORMAL',
  INVERTED = 'INVERTED',
}
